import { render, staticRenderFns } from "./ProfileRaiseAlert.vue?vue&type=template&id=4f19127c&scoped=true&"
import script from "./ProfileRaiseAlert.vue?vue&type=script&lang=js&"
export * from "./ProfileRaiseAlert.vue?vue&type=script&lang=js&"
import style0 from "./ProfileRaiseAlert.vue?vue&type=style&index=0&id=4f19127c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f19127c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4f19127c', component.options)
    } else {
      api.reload('4f19127c', component.options)
    }
    module.hot.accept("./ProfileRaiseAlert.vue?vue&type=template&id=4f19127c&scoped=true&", function () {
      api.rerender('4f19127c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/raise_alert/ProfileRaiseAlert.vue"
export default component.exports